












































































































import { Component, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import { Quill } from "vue-quill-editor";
import { ImageDrop } from "quill-image-drop-module";
import AnnoucementService from "@/services/Annoument.service";
import GenericAdd from "../../core/Generics/GenericAdd";
import Porposal from "@/models/porposal/porposal.model";
import { PorposalModality } from "@/enums/PorposalModality";
import CoinService from "@/services/coins.service";
import { PorposalExpectedResult } from "@/enums/PorposalExpectedResult";
import ProposalMember from "../../models/porposal/porposalMembers.model";
import ProposalDocument from "@/models/porposal/proposalDocument.Model";
import MemberTypeService from "@/services/memberType.service";
import ProjectTypeService from "@/services/projectType.service";
import DocumentComponent from "@/components/PublishAnnoucement/document.vue";
import GenericEdit from "../../core/Generics/GenericEdit";
import Document from "../../models/document.model";
import ProposedConsortium from "@/models/porposal/proposedConsortium.Model";
import moment from "moment";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import PorposalBudgetItem from "@/models/porposal/porposalBudgetItem.model";
import { BudgetItemCalculation } from "@/enums/BudgetItemCalculation";
import BudgetExpenseService from "@/services/budgetExpense.service";
import AnnoucementAreasService from "@/services/AnnoumentArea.service";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import ResearchCenterService from "@/services/researchCenter.service";
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue"
import DocumentComponentViewer from "@/components/document-component-view/documentComponentViewer.vue"
import UserService from '@/services/user.service';
import PorposalService from '@/services/porposal.service';
import PorposalDetail from '@/components/porposal-detail-component/detail-optimized.vue'
//import PorposalDetail from '@/components/porposal-detail-component/detail.vue'
import { ProposalState } from '@/enums/ProposalState';

@Component({
  components: { DatePickerComponent, documentcomponent: DocumentComponent, ResearchCenterBasicInformationComponent, UserBasicInformationComponent, DocumentComponentViewer, PorposalDetail }
})
export default class PorposalDetailResearchCenter extends GenericEdit<Porposal> {
  currentTab = 1;
  memberTypes: any = [];
  projectTypes: any = [];
  isComponentModalActive: boolean = false;
  areas: any = [];
  motivoDevolucion: string = null;
  accionARealizar: string = null;
  fieldAreas: any = [];
  fieldAreasResearchLines: any = [];
  researchCenter: any = null;
  PorposalModality = PorposalModality;
  PorposalExpectedResult = PorposalExpectedResult;
  annoucementService: AnnoucementService = new AnnoucementService();
  CoinService = new CoinService();
  memberTypeService: MemberTypeService = new MemberTypeService();
  projectTypeService: ProjectTypeService = new ProjectTypeService();
  annoucementAreasService: AnnoucementAreasService = new AnnoucementAreasService();
  researchCenterService: ResearchCenterService = new ResearchCenterService();
  userService: UserService = new UserService();
  proposalService: PorposalService = new PorposalService();
  researchCenters = [];
  counter: number;
  words: any;
  loading = false;
  dropFiles = [];
  Coins: [];
  annoucementId: number | null = null;
  years: Array<number> = [];
  budgetExpenses = [];
  budgetItemCurrent = new PorposalBudgetItem();
  showAddPartida = false;
  budgetExpenseService = new BudgetExpenseService();
  BudgetItemCalculation = BudgetItemCalculation;
  totalBudgetFondocyt: number = 0;
  totalBudgetInstitutionalAport: number = 0;
  showWarning = false;
  annoucementTitle = "";
  devuelto: ProposalState = ProposalState.DevueltoCI;
  rechazado: ProposalState = ProposalState.RechazadoCI;
  aprobado: ProposalState = ProposalState.EnviadoFC;
  movimientos: [] = [];

  constructor() {
    super();
    this.controller = "Porposal/GetFondocytRequiredInformationIES";
    this.model = new Porposal();
    this.Coins = [];
    this.counter = 0;
    this.words = "";

    Quill.register("modules/imageDrop", ImageDrop);
  }

  get isDisabled () {
    return this.model.estado == this.devuelto 
      || this.model.estado == this.aprobado  
      || this.model.estado == this.rechazado 
      ? true 
      : false;
  }

  aprobarPropuesta() {
     this.$buefy.dialog.confirm({
      title: '¿Estás seguro?',
      message: 'Si apruebas esta propuesta será enviada inmediatamente a FONDOCyT.',
      confirmText: 'Sí',
      type: 'is-warning',
      hasIcon: true,
      cancelText: "Cancelar",
      onConfirm: () => {
    this.loading = true;
    let model = {
      id: parseInt(this.$route.params.id),
      motivo: this.motivoDevolucion
    }
    this.proposalService.aprobarPropuestaCI(model).then(response => {
        if (response) {
          this.movimientos = response;
          this.$buefy.toast.open({
            message:
              "Se ha aprobado exitosamente ",
            type: "is-success",
            duration: 2000
          });
        }
        this.loading = false;
        this.model.estado = this.aprobado;
    });
      }
      });
  }
  @Watch("annoucementId")
  getEvaluators() {
    
    this.annoucementService
      .getDetailAnnocement(this.model.annoucementId)
      .then(response => {
        if (response) {
          this.annoucementTitle = response.title;
        }
      });
  }

  rechazarPropuesta(model) {
    this.$buefy.dialog.confirm({
      title: 'Estas seguro?',
      message: 'Si rechazas esta propuesta no podrás realizar más acciones sobre la misma.',
      confirmText: 'Sí',
      type: 'is-danger',
      hasIcon: true,
      cancelText: "Cancelar",
      onConfirm: () => {
        this.loading = true;
        this.isComponentModalActive = false;
        this.proposalService.rechazarPropuesta(model).then(response => {
          if (response) {
            this.movimientos = response;
            this.$buefy.toast.open({
              message:
                "Se ha rechazado exitosamente ",
              type: "is-success",
              duration: 2000
            });
          }
          this.loading = false;
          this.model.estado = this.rechazado;
        });
      }
    })
  }

  mostrarModal(accion) {
    this.isComponentModalActive = true;
    this.accionARealizar = accion;
  }

  realizarAccionSobreLaPropuesta() {
    let model = {
      id: parseInt(this.$route.params.id),
      motivo: this.motivoDevolucion
    }

    if (this.motivoDevolucion && this.motivoDevolucion != "") {
      if (this.accionARealizar === 'devolver') {
        this.devolverPropuesta(model);
      } else if (this.accionARealizar === 'rechazar') {
        this.rechazarPropuesta(model);
      } 
    } else {
      this.$buefy.toast.open({
        message:
          "Debe escribir un motivo.",
        type: "is-warning",
        duration: 2000
      });
    }
     
  }
  devolverPropuesta(model) {
    this.loading = true;
    this.isComponentModalActive = false;
    this.proposalService.devolverPropuesta(model).then(response => {
        if (response) {
          this.movimientos = response;
          this.$buefy.toast.open({
            message:
              "Se ha devuelto exitosamente ",
            type: "is-success",
            duration: 2000
          });
        }
        this.loading = false;
        this.model.estado = this.devuelto;
    });
  }


  protected async getData() {
    try {
      this.loading = true;
      let response = await this.repository.byId(this.id, this.include);
      if (response.startDate) response.startDate = new Date(response.startDate);
      if (response.endDate) response.endDate = new Date(response.endDate);
      
      this.model = response;
      this.annoucementId = this.model.annoucementId as number;
      this.modelInit = this.map<Porposal>(this.model);
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }


  get user() {
    return this.$store.state.user;
  }

  public getcenterByInvestigatorId(){
      if (this.userService) {
          this.userService.researchCenterByInvestigator(this.user.id).then(center=>{
          this.researchCenters = center;
          });
      }
  }
}
